export const Z_INDEX_MAX = 2147483647

export const PAGE_LINKS = {
  home: '/',
  login: '/login',
  wxLogin: '/wxlogin',
}

export enum PPT_ACTION_ENUM {
  edit = 'edit',
  preview = 'preview',
  play = 'play',
}

// 错误码
export enum ErrorCodeEnum {
  /**
   * 权限不足
   */
  NotAuthorized = 10031,
  /**
   * Token 过期、无效
   */
  TokenInvalid = 10032,
  /**
   * 用户错误
   */
  UserError = 10033,
  /**
   * 缺少 token
   */
  MissingToken = 10034,
}
